import config from '../../../../config'

// The Shopify custom pixel a brand pastes into Shopify Admin > Settings >
// Customer events. It runs in Shopify's sandbox and posts each event to the
// API's /shopify/events collector (desirelist-api lib/shopifyPixel), keyed
// by the brand's public token. Shape changes here must stay in step with
// that collector's parsePixelEvent (schema_version 1). Keep each
// analytics.subscribe a literal call with a literal event name: Shopify
// detects subscriptions statically and rejects a pixel it can't see any in.
export function shopifyPixelSnippet(publicToken: string): string {
  // PUBLIC_API_URL, not API_URL: the pixel runs on the store, which can't
  // reach a local API at localhost (config: ngrok tunnel locally).
  const endpoint = `${config.PUBLIC_API_URL || config.API_URL}/shopify/events`
  // Compact on purpose (brands paste it into a small Shopify editor), but
  // hand-written: a minifier could fold the subscribe calls into a loop.
  return `// TDC Shopify Pixel — public store id only, never a secret key.
const E="${endpoint}",S="${publicToken}";
const it=(v,q=1)=>({product_id:v?.product?.id??null,variant_id:v?.id??null,sku:v?.sku??null,quantity:q,unit_price:v?.price?.amount??null,currency:v?.price?.currencyCode??null});
function send(e){const d=e.data??{},c=d.checkout,l=e.context?.document?.location,p={schema_version:1,store_id:S,event_id:e.id,event_name:e.name,occurred_at:e.timestamp,client_id:e.clientId,page:{hostname:l?.hostname??null,pathname:l?.pathname??null}};
if(e.name==="product_viewed")p.items=[it(d.productVariant)];
else if(e.name==="product_added_to_cart")p.items=[it(d.cartLine?.merchandise,d.cartLine?.quantity)];
else if(c)Object.assign(p,{order_id:c.order?.id??null,checkout_token:c.token??null,currency:c.currencyCode??null,total:c.totalPrice?.amount??null,items:(c.lineItems??[]).map((i)=>it(i.variant,i.quantity))});
fetch(E,{method:"POST",headers:{"Content-Type":"text/plain;charset=UTF-8"},credentials:"omit",keepalive:true,body:JSON.stringify(p)}).catch(()=>{});}
analytics.subscribe("page_viewed",send);
analytics.subscribe("product_viewed",send);
analytics.subscribe("product_added_to_cart",send);
analytics.subscribe("checkout_started",send);
analytics.subscribe("checkout_completed",send);
`
}
